import { render, staticRenderFns } from "./FarmTable.vue?vue&type=template&id=4b492230&"
import script from "./FarmTable.vue?vue&type=script&lang=js&"
export * from "./FarmTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports